import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { Flex, Button } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { TopBar } from '@component/top_bar.component';
import { useResolveController, useService } from '@visiba/instantiation';
import { useEffect } from 'react';
import { Title } from '@component/title.component';
import styled from 'styled-components';
import { Illustration } from '@component/illustration/mod';
import { ButtonArrange } from '@component/button_arrange.component';
import { ViewRedRobinController } from '../view_red_robin.controller';
import { UniversalConfig } from '@application/universal_config.service';

const elements = {
	container: styled(Flex)`
		text-align: center;
		max-width: 400px;
	`,
	illustration: styled(Illustration)`
		width: 200px;
		/* height: 125px; */
		max-width: 100%;
	`,
};

export function ScreenClosed() {
	const controller = useResolveController(ViewRedRobinController);
	const universalConfig = useService(UniversalConfig);
	const analytics = useAnalyticContext();

	const closedReason = controller.flowData.value.value?.closedReason ?? 'Other';

	function handleGoToHome() {
		analytics.trackEvent('Clicked start over');
		controller.goToReceptionHome();
	}

	function numbers() {
		const country = universalConfig.selectedCountryCode.peek();

		switch (country) {
			case 'SE':
				return {
					emergency: '112',
					nonEmergency: '1177',
				};
			case 'NO':
				return {
					emergency: '113',
					nonEmergency: '116 117',
				};
			case 'FI':
				return {
					emergency: '112',
					nonEmergency: '116 117',
				};
			case 'GB':
				return {
					emergency: '999',
					nonEmergency: 'NHS 111',
				};
		}

		return {
			emergency: '-',
			nonEmergency: '-',
		};
	}

	useEffect(
		function whenMounted() {
			analytics.service.trackPageView({
				customTitle: 'RedRobin: Closed',
			});
		},
		[analytics],
	);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<Flex gap={tokens.spacing.x4} grow={1} align='center' justify='center'>
				<elements.container align='center' gap={tokens.spacing.x2_5} grow={1}>
					<elements.illustration type='closed' />
					<Title
						title={withTranslation(`View.RedRobin.Closed.${closedReason}Title`)}
						titleSize='small'
						description={withTranslation(`View.RedRobin.Closed.${closedReason}Body`, {
							emergencyNumber: numbers().emergency,
							nonEmergencyNumber: numbers().nonEmergency,
						})}
					/>
				</elements.container>
				<Flex style={{ width: '100%' }}>
					<ButtonArrange justify='center'>
						<Button variant='primary' onClick={handleGoToHome}>
							{withTranslation('View.RedRobin.Closed.Button')}
						</Button>
					</ButtonArrange>
				</Flex>
			</Flex>
		</>
	);
}
